import React, { Component } from 'react';
import withWidth from '@material-ui/core/withWidth';
import { AppBarMobile, GET_LIST, GET_MANY } from 'react-admin';
import NumberOfTeamsQuery from './NumberOfTeamsQuery'
import GamesSummary from './GamesSummary'

import restClient from '../restClient';
import AlarmReport from './AlarmReport';

const styles = {
  welcome: { marginBottom: '2em' },
  flex: { display: 'flex' },
  itemArea: { display: 'flex', backgroundColor:"#efefef", padding:"10px" },
  leftCol: { flex: 1, marginRight: '1em' },
  rightCol: { flex: 1, marginLeft: '1em' },
  singleCol: { marginTop: '2em' },
  divider:{margin: '25px', borderBottom: "1px solid grey"}
};

class Dashboard extends Component {
  state = {};

  componentDidMount() {}

  render() {
    const {} = this.state;
    const { width } = this.props;
    return (
      <div>
        {width === 1 && <AppBarMobile title="Seppo Reporting" />}
        <div style={styles.flex}>
          <div style={styles.singleCol}>
            <div style={styles.itemArea}>
              <GamesSummary {...this.props}/>
            </div>
            <div style={styles.divider}/>
            <div style={styles.itemArea}>
              <NumberOfTeamsQuery {...this.props}/>
            </div>
            <div style={styles.divider}/>
            <div style={styles.itemArea}>
              <AlarmReport {...this.props}/>
            </div>
            <div style={styles.flex} />
          </div>
        </div>
      </div>
    );
  }
}

export default withWidth()(Dashboard);



// WEBPACK FOOTER //
// ./src/dashboard/index.js